import { useState, useEffect } from 'react'
import Axios from 'axios'
import Chart from 'react-apexcharts'
import WarningModal from '../components-modals/WarningModal'

/*const data = [
    {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 793784.5,
        "9": 760912,
        "10": 549372,
        "11": 0,
        "12": 0,
        "NombrePlan": "PC-Cito",
        "IdPlan": 1
    },
    {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1437390.5,
        "9": 1498828,
        "10": 914411,
        "11": 0,
        "12": 0,
        "NombrePlan": "Colegio",
        "IdPlan": 2
    },
    {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 67298,
        "9": 56587,
        "10": 48151,
        "11": 0,
        "12": 0,
        "NombrePlan": "Fin de Semana",
        "IdPlan": 3
    },
    {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 65911,
        "9": 53627,
        "10": 25105,
        "11": 0,
        "12": 0,
        "NombrePlan": "Plan 4",
        "IdPlan": 4
    }
]*/

const params = {
    "Opcion": "0",
    "FIni": "20220801",
    "FFin": ""
}

const IngresosPorPlan = ({ url, headers, FFin, setLoadingAPIS }) => {

    params.FFin = FFin

    //const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Axios({
                    method: 'get',
                    url: url,
                    headers: headers,
                    params: params
                })
                setData(response.data)
                setLoadingAPIS(curr => ({...curr, IngresosPorPlan: true}))
            } catch (err) {
                console.log(err)
            }
        }
        fetchData()
    }, [])

    const series = dataFormatter(data)

    const chartOptions = {
        chart: {
            type: 'bar',
            height: 520,
            stacked: true,
            toolbar: {
                show: true
            },
            zoom: {
                enabled: true
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                },
            }
        },
        ],
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 1000,
                barHeight: '100%',
                columnWidth: '50%',
            },
        },
        xaxis: {
            type: 'category',
            labels: {
                style: {
                    colors: Array(12).fill('#9197a1')
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: ['#9197a1']
                },
                formatter: (value) => {
                    return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
                },
            }
        },
        legend: {
            position: 'right',
            offsetY: 40
        },
        fill: {
            opacity: 1
        },
        colors: ['#4782da', '#2e4b76', '#9197a1', '#E68A00'],
        dataLabels: {
            enabled: false,
            style: {
                colors: ['#fff']
            },
            formatter: (value) => {
                return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
            },
        },
        legend: {
            show: true,
            labels: {
                colors: ['#fff']
            }
        },
        tooltip: {
            y: {
                formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
                    return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
                }
            }
        },
        grid: {
            show: false,
        },
    }

    const newCategories = data.length > 0
    ? Object.keys(data[0]).slice(2)
    : []

    chartOptions.xaxis.categories = newCategories;

    return (
        <>
            <div className='bg-primarioMira rounded-lg p-5'>
                <h2 className="text-lg font-medium leading-6 text-white">Ingreso por plan de estudios</h2>
            </div>
            {/*<WarningModal
                open={loading ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />*/}
            <div className='p-5'>
                <Chart
                    options={chartOptions}
                    series={series}
                    height='330px'
                    type="bar"
                />
            </div>
        </>
    )
}

export default IngresosPorPlan

const dataFormatter = (objArray = []) => {

    let arr = []

    objArray.map((obj) => {
        return arr.push({
            name: Object.values(obj)[0],
            data: Object.values(obj).slice(2)
        })
    })

    return arr
}